var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_vm._t("default"),_vm._v(" "),_c('video',{ref:"video",attrs:{"poster":_vm.imageURL,"id":"video","controls":""}},[_c('source',{attrs:{"src":_vm.resourceURL,"type":"video/mp4"}}),_vm._v("Sorry. Your browser doesn't support video.\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eab3cc7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared-components/video.vue
// module id = null
// module chunks = 